export const UNIT_DATE_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Date is required',
  },
  {
    test: (v) => v <= '2100-12-31',
    message: 'Date must be on or before 31 Dec 2100',
  },
];
